/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Ellipse } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberZero(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Ellipse
        cx={128}
        cy={128}
        rx={72}
        ry={104}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default NumberZero;
